import gateway from './Gateway';

gateway();
